// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampusAccessToday_wrapper__ieMH0","separator":"CampusAccessToday_separator__gg5Vi","dot":"CampusAccessToday_dot__Dfi0a"};